// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6b5f1712","239":"fd5b19cd","455":"56e879eb"}[chunkId] + ".chunk.js";
};